import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import ActionsFormatter from './ActionsFormatter';
import InstallationTypeFormatter from './InstallationTypeFormatter';

const ProductColumns = ({
    filterData,
    handleClickBulkItems,
    handleClickDelete,
    handleClickUpdate,
    roofTypesToSelect,
    rowModesModel,
    selectedRowId,
    setRowModesModel,
    setSelectedRowId,
}) => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();

    const nameColumn = {
        align: 'left',
        display: 'flex',
        editable: true,
        field: 'name',
        headerName: t('System'),
        minWidth: 300,
        renderCell: (params) => {
            const { row } = params;
            return (
                <Typography variant="caption" fontWeight="bold">
                    {row.name}
                </Typography>
            );
        },
    };

    const countryColumn = {
        align: 'left',
        display: 'flex',
        editable: true,
        field: 'country',
        headerName: t('Country'),
        minWidth: 180,
        renderCell: (params) => {
            const { row } = params;
            return (
                <Typography variant="caption">{row?.country?.name}</Typography>
            );
        },
    };

    const actionsColumn = {
        align: 'left',
        display: 'flex',
        field: '',
        flex: 1,
        renderCell: (params) => {
            const { row } = params;
            return (
                <ActionsFormatter
                    filterData={filterData}
                    handleClickBulkItems={handleClickBulkItems}
                    handleClickDelete={handleClickDelete}
                    handleClickUpdate={handleClickUpdate}
                    row={row}
                    rowModesModel={rowModesModel}
                    selectedRowId={selectedRowId}
                    setRowModesModel={setRowModesModel}
                    setSelectedRowId={setSelectedRowId}
                />
            );
        },
    };

    if (['xs', 'sm'].includes(breakpoint)) {
        return [nameColumn, actionsColumn];
    }

    return [
        nameColumn,
        {
            align: 'left',
            display: 'flex',
            field: 'type_application',
            flex: 1,
            minWidth: 300,
            headerName: t('Type application'),
            renderCell: (params) => {
                const { row } = params;
                const rooftType = roofTypesToSelect.find(
                    (roof) => roof.value === row.type_application,
                );

                return (
                    <InstallationTypeFormatter
                        typeApplication={rooftType?.label}
                    />
                );
            },
        },
        countryColumn,
        actionsColumn,
    ];
};

ProductColumns.propTypes = {
    canDelete: PropTypes.bool,
    canUpdate: PropTypes.bool,
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickDelete: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    rowModesModel: PropTypes.object,
    selectedRowId: PropTypes.func,
    setRowModesModel: PropTypes.func,
    setSelectedRowId: PropTypes.func,
};

export default ProductColumns;
